module.exports = __webpack_public_path__ + "img/10.a0f138a2.png";